// ----------------------------------------------------------------------
// <copyright file="Izenda.MonthlyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var m = require('mobx-react');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var Dropdown = require('share/components/controls/Izenda.DropDown');
  var ScheduleConstants = require('logic/data/Izenda.ScheduleConstants');
  var localizer = require('share/localization/Izenda.Localizer');

  var MonthlyRecurrence = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function () {
      this.recurrence = this.props.data.monthlyRecurrencePatternSetting;
    },
        
    /**
     * Check day radio
     */
    getCheckedDay: function () {
      return !this.recurrence.useOrdinalDay;
    },
        
    /**
     * onchange day radio
     */
    onChangeDay: function (input) {
      this.recurrence.useOrdinalDay = false;
      this.props.data.markDirty();
    },
        
    /**
     * Get day
     */
    getDay: function () {
      return this.recurrence.day;
    },
        
    /**
     * onchange day input
     */
    onChangeDayInput: function (input) {
      this.recurrence.day = input.target.value;
      this.props.data.markDirty();
    },
        
    /**
     * Get month
     */
    getMonth: function () {
      return this.recurrence.recurrenceMonth;
    },
        
    /**
     * Check day radio
     */
    getCheckedThe: function () {
      return this.recurrence.useOrdinalDay;
    },
        
    /**
     * Onchange The radio
     */
    onChangeThe: function (input) {
      this.recurrence.useOrdinalDay = true;
      this.props.data.markDirty();
    },
        
    /**
     * onchange month input
     */
    onChangeMonth: function (input) {
      this.recurrence.recurrenceMonth = input.target.value;
      this.props.data.markDirty();
    },
        
    /**
     * get ordinal day
     */
    getOrdinal: function () {
      return this.recurrence.ordinalDay || ScheduleConstants.ORDINAL_LIST[0];
    },
        
    /**
     * onchange ordinal day
     */
    onChangeOrdinal: function (input) {
      this.recurrence.ordinalDay = input.value;
      this.props.data.markDirty();
    },
        
    /**
     * get day name
     */
    getDayName: function () {
      return this.recurrence.ordinalDayValue || ScheduleConstants.DAYNAME_LIST[0];
    },
        
    /**
     * onchange day name
     */
    onChangeDayName: function (input) {
      this.recurrence.ordinalDayValue = input.value;
      this.props.data.markDirty();
    },
        
    /**
     * get ordinal month
     */
    getOrdinalMonth: function () {
      return this.recurrence.ordinalRecurrenceMonth;
    },
        
    /**
     * onchange ordinal month dropdownlist
     */
    onChangeOrdinalMonth: function (input) {
      this.recurrence.ordinalRecurrenceMonth = input.target.value;
      this.props.data.markDirty();
    },
        
    /**
     * Render component
     */
    render: function () {
      return (
        <div>
          <div className='form-group'>
            <div className='col-md-3'>
              <Input type='radio'
                name='monthlyRecurrence'
                checked={this.getCheckedDay()}
                onChange={this.onChangeDay} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_DAY')}</span>
            </div>
            <div className='col-md-2'>
              <Input value={this.getDay() }
                onChange={this.onChangeDayInput}
                disabled={this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-1 no-padding-left control-label'>{localizer.getText('SUBSCRIPTION_LABEL_OF_EVERY')}</div>
            <div className='col-md-2 no-padding-left'>
              <Input value={this.getMonth() }
                onChange={this.onChangeMonth}
                disabled={this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-3 no-padding-left control-label'>{localizer.getText('SUBSCRIPTION_LABEL_MONTHS')}</div>
          </div>
          <div className='form-group'>
            <div className='col-md-3'>
              <Input type='radio'
                name='monthlyRecurrence'
                checked={this.getCheckedThe() }
                onChange={this.onChangeThe} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_THE')}</span>
            </div>
            <div className='col-md-2'>
              <Dropdown options={ScheduleConstants.ORDINAL_LIST}
                value={this.getOrdinal() }
                onChange={this.onChangeOrdinal}
                disabled={!this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-2 no-padding-left'>
              <Dropdown options={ScheduleConstants.DAYNAME_LIST}
                value={this.getDayName() }
                onChange={this.onChangeDayName}
                disabled={!this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-1 no-padding-left control-label'>{localizer.getText('SUBSCRIPTION_LABEL_OF_EVERY')}</div>
            <div className='col-md-2 no-padding-left'>
              <Input value={this.getOrdinalMonth() }
                onChange={this.onChangeOrdinalMonth}
                disabled={!this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-1 no-padding-left control-label'>{localizer.getText('SUBSCRIPTION_LABEL_MONTHS')}</div>
          </div>
        </div>
      );
    }
  });

  module.exports = m.observer(MonthlyRecurrence);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.MonthlyRecurrence.jsx